import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('crmContatti');
export const actions = helper.createActions('crmContatti', actionTypes);